import { ColSize, SelectionGridColumn } from '../../../utils/grid-util';

const carServiceDashboardGroupColumn: SelectionGridColumn = {
	colsList: [
		{
			headerName: '대상 그룹 아이디',
			field: 'dashboardGroupId',
			flex: 1,
			minWidth: ColSize.CW_SMALL,
		},
		{
			headerName: '그룹명',
			field: 'dashboardGroupName',
			flex: 1,
			minWidth: ColSize.CW_SMALL,
		},
		{
			headerName: '메모',
			field: 'dashboardGroupMemo',
			flex: 1,
			minWidth: ColSize.CW_SMALL,
		},
	],
	forms: [],
};

export default carServiceDashboardGroupColumn;
